<div class="checkbox-row clickable">
  <span class="checkbox-icon" (click)="onClick()">
    @if (!checked) {
      <span class="checked-none"></span>
    }
    @if (checked) {
      <span class="checked-all"></span>
    }
  </span>

  <span hidden>{{value}}</span>
  <span class="checkbox-text" (click)="onClick()">{{text}}</span>
</div>